<template>
  <b-form-group
    label="Cores:"
    label-for="nested-street"
    label-cols-sm="2"
    label-align-sm="right"
  >
    <vue-range-slider
      ref="sliderCores"
      :min="1"
      :height="10"
      :max="4"
      :speed="0.2"
      v-model="cores"
    ></vue-range-slider>
    <br />
  </b-form-group>
</template>

<script>
import "vue-range-component/dist/vue-range-slider.css";
import VueRangeSlider from "vue-range-component";
export default {
  props: {
    value: {
      type: Number,
    },
  },
  components: {
    VueRangeSlider,
  },
  created: function () {
    VueRangeSlider.methods.handleKeyup = () => console.log;
    VueRangeSlider.methods.handleKeydown = () => console.log;
  },
   updated() {
    this.$nextTick(function () {
      this.$refs.sliderCores.refresh();
    });
  },
  computed: {
    cores: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
<style scoped>
.inline-block-child {
  display: inline-block;
  margin-right: 10px;
}
</style>